export default __webpack_public_path__ + "static/media/Varsun_Partners.a9c93618.png";